// import anime from 'animejs'
// import axios from 'axios'

import cardTpl from './cards-templates/edit-map'

export default {
  name: 'edit-implants',

  ui: {
    btAdd: '[js-bt-add]',
    'btNav[]': '[js-map-filter]',
  },

  events: [
    {
      target: 'btAdd',
      on: 'click',
      handle () {
        const div = document.createElement('div')
        div.innerHTML = cardTpl({ type: this.type, id: Date.now() })
        this.list.append(div.querySelector('.card'))
      },
    },
    {
      target: 'btNav',
      on: 'click',
      handle (e) {
        const bt = e.currentTarget
        this.type = bt.getAttribute('js-map-filter')
        const cards = this.list.querySelectorAll('.card')

        // for (let btn of this.ui.btNav) {
        Array.prototype.forEach.call(this.ui.btNav, btn => {
          if (btn !== bt) {
            btn.classList.remove('is-active')
          }
        })
        // bt.classList.toggle('is-active')
        bt.classList.add('is-active')

        if (bt.classList.contains('is-active')) {
          // for (let item of cards) {
          Array.prototype.forEach.call(cards, item => {
            if (item.getAttribute('data-type').indexOf(this.type) === -1) {
              item.classList.add('hidden')
            } else {
              item.classList.remove('hidden')
            }
          })
        } else {
          // for (let item of cards) {
          Array.prototype.forEach.call(cards, item => {
            item.classList.remove('hidden')
          })
        }

        if (bt.getAttribute('js-map-filter') === 'headoffice') {
          this.ui.btAdd.classList.add('invisible')
        } else {
          this.ui.btAdd.classList.remove('invisible')
          this.ui.btAdd.setAttribute(
            'data-type',
            bt.getAttribute('js-map-filter')
          )
        }
      },
    },
  ],

  componentDidMount () {
    this.nav = this.el.querySelectorAll('ul')[0]
    this.list = this.el.querySelector('.cards-list')
    this.ui.btNav[0].click()
  },
}
